<template>
    <error-content code="401" :desc="L('Validate.Error401')" :src="src"/>
</template>

<script>
    import base from '../../../lib/utils/types/base'
    import error401 from '@/assets/img/error-page/error-401.svg'
    import errorContent from './components/error-content.vue'
    export default {
        name: 'error_401',
        components: {
            errorContent
        },
        data () {
            return {
                src: error401
            }
        },
        methods:{
            L(key){
                return base.L(key);
            }
        }
    }
</script>
